export class FreeReducedMealAppIncome {
    ID: number;
    Amount: number;
    Frequency: string ;
    Hours: number;
    Per: string ;
    ConvertedToAnnual: number;

    // client-only properties
    hasFocus: boolean;
   }